module.exports = __webpack_public_path__ + "img/finance-application-display-mazda.1e31b15b.png";